export default __webpack_public_path__ + "static/media/ic-back.5b6279f2.svg";